export default function HealthClasses() {
  let options = [
    { label: "Exceptionally healthy (Preferred Plus)", value: "PP" },
    { label: "Very healthy (Preferred)", value: "P" },
    { label: "Above average health (Standard Plus)", value: "RP" },
    { label: "Average health (Standard)", value: "R" }
  ];
  return options;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/HealthClasses.js